import { IsBoolean, IsInt, IsISO8601, IsOptional, Matches, Max, Min } from 'class-validator';
import { Type } from 'class-transformer';

export class StockLevelParamDto {
  @IsOptional()
  @IsInt()
  @Type(() => Number)
  merchantId: number;

  @IsOptional()
  @IsInt()
  @Min(1970)
  @Max(2100)
  @Type(() => Number)
  year: number;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Max(12)
  @Type(() => Number)
  monthNo: number;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Max(53)
  @Type(() => Number)
  weekNo: number;

  @IsOptional()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  countedDate: string;

  @IsOptional()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  date: string;

  @IsOptional()
  @IsBoolean()
  beforeTrading: boolean;
}